import React from 'react';
import { Pagination } from 'react-bootstrap';

// Paginação client-side reutilizável (padrão do projeto: First/Prev/números
// com ellipsis/Next/Last + "Mostrando X até Y de Z"). Some quando há 1 página.
const MAX_BOTOES = 5;

const Paginacao = ({
  paginaAtual,
  totalPaginas,
  totalRegistros,
  itensPorPagina,
  mudarPagina,
}) => {
  if (totalPaginas <= 1) return null;

  let inicio = Math.max(1, paginaAtual - Math.floor(MAX_BOTOES / 2));
  let fim = Math.min(totalPaginas, inicio + MAX_BOTOES - 1);
  if (fim - inicio < MAX_BOTOES - 1) {
    inicio = Math.max(1, fim - MAX_BOTOES + 1);
  }

  const numeros = [];
  for (let n = inicio; n <= fim; n += 1) {
    numeros.push(n);
  }

  const primeiroRegistro =
    totalRegistros > 0 ? (paginaAtual - 1) * itensPorPagina + 1 : 0;
  const ultimoRegistro = Math.min(paginaAtual * itensPorPagina, totalRegistros);

  return (
    <div className="d-flex flex-wrap justify-content-between align-items-center mt-3">
      <div className="text-muted small mb-2">
        Mostrando {primeiroRegistro} até {ultimoRegistro} de {totalRegistros}{' '}
        registros
      </div>
      <Pagination className="mb-0">
        <Pagination.First
          onClick={() => mudarPagina(1)}
          disabled={paginaAtual === 1}
        />
        <Pagination.Prev
          onClick={() => mudarPagina(paginaAtual - 1)}
          disabled={paginaAtual === 1}
        />
        {inicio > 1 && <Pagination.Ellipsis disabled />}
        {numeros.map(n => (
          <Pagination.Item
            key={n}
            active={n === paginaAtual}
            onClick={() => mudarPagina(n)}
          >
            {n}
          </Pagination.Item>
        ))}
        {fim < totalPaginas && <Pagination.Ellipsis disabled />}
        <Pagination.Next
          onClick={() => mudarPagina(paginaAtual + 1)}
          disabled={paginaAtual === totalPaginas}
        />
        <Pagination.Last
          onClick={() => mudarPagina(totalPaginas)}
          disabled={paginaAtual === totalPaginas}
        />
      </Pagination>
    </div>
  );
};

export default Paginacao;
